import { Provider } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { SESSION_ID } from '@cigna/shared/angular/core/interfaces-util';

export const sessionIdFactory = (cookies: CookieService) =>
  cookies.get('USER_SESSION_FP');

export const SESSION_ID_PROVIDER: Provider = {
  provide: SESSION_ID,
  useFactory: sessionIdFactory,
  deps: [CookieService],
};
